module.exports = __webpack_public_path__ + "img/ShougangFund.00b4ecf3.png";